import { get } from '../http';

export const getByCountryCode = code => get(`v2/GolfClubs/country=${code}`);
